/* eslint-disable */
import { Link as RouterLink } from 'react-router-dom';
import {
  AppBar,
  Box,
  Button,
  Divider,
  Hidden,
  IconButton,
  Toolbar,
} from '@material-ui/core';
import MenuIcon from 'src/icons/Menu';
import { useStyles } from '../style';
import LogoNavBar from '../LogoNavBar';

const FaqNavbar = (props) => {
  const classes = useStyles();
  const { onSidebarMobileOpen } = props;

  return (
    <AppBar className={classes.appBar}>
      <Toolbar sx={{ minHeight: 64 }}>
        <Hidden mdUp>
          <IconButton onClick={onSidebarMobileOpen} sx={{ color: '#001930' }}>
            <MenuIcon fontSize="large" />
          </IconButton>
        </Hidden>
        <RouterLink to="/">
          <LogoNavBar
            sx={{
              textAlign: 'left',
              height: 40,
              width: 210,
            }}
          />
        </RouterLink>
        {/* <Box sx={{ flexGrow: 1 }} /> */}
        <Hidden mdDown>
          <Box className={classes.boxContainer}>
            <Button href="/#what" component="a" sx={{ textAlign: 'center' }}>
              Qué hacemos
            </Button>
            <Button href="/#video" component="a" sx={{ textAlign: 'center' }}>
              Así funcionamos
            </Button>
            <Button href="/#how" component="a" sx={{ textAlign: 'center' }}>
              Cómo lo hacemos
            </Button>
            <Button
              href="/#advantage"
              component="a"
              sx={{ textAlign: 'center' }}
            >
              Ventajas competitivas
            </Button>
            <Button
              href="/#benefit"
              component="a"
              sx={{ textAlign: 'center', ml: 1 }}
            >
              Beneficios
            </Button>
            <Button
              href="/#contact"
              component="a"
              sx={{ textAlign: 'center', ml: 1 }}
            >
              Contacto
            </Button>
            <Button
              sx={{
                backgroundColor: '#FCBE00',
                textAlign: 'center',
                minWidth: '117px',
                ml: 1,
                '&:hover': {
                  backgroundColor: '#fbd972',
                },
              }}
              component="a"
              href="/authentication/login"
              variant="contained"
            >
              Iniciar sesión
            </Button>
          </Box>
        </Hidden>
      </Toolbar>
      <Divider />
    </AppBar>
  );
};

export default FaqNavbar;
